import { gql } from '@apollo/client'

// TODO: I would like to update this name,  FetchProjectV2ForProjectJourneyQuery,
// but changes to this query don't seem to update codegen-federation. I must have
// forgotten how that works.
export const GET_PROJECT_PHASES = gql`
  query fetchProjectPhasesForProjectJourney($projectSlug: String!) {
    project(slug: $projectSlug) {
      id
      slug
      name
      primaryFlowPhases {
        id
        status
        updatedAt
        phaseName
        phaseSlugEnum
        departmentSlugEnum
        releaseWindows {
          start
        }
      }
    }
  }
`

export const GET_PROJECT = gql`
  query fetchProjectForProjectJourney($projectUuid: String!) {
    guildUpdates(input: { projectId: $projectUuid }) {
      id
    }
  }
`
